import Hashids from 'hashids';

// Create a Hashids instance with a salt (keep this secret in production)
const hashids = new Hashids('your-secret-salt-here', 8); // 8 is minimum length

/**
 * Encode a numeric ID to a hash
 * @param {number} id - The numeric ID to encode
 * @returns {string} - The encoded hash
 */
export const encodeId = (id) => {
  if (!id || isNaN(id)) return '';
  return hashids.encode(id);
};

/**
 * Decode a hash back to numeric ID
 * @param {string} hash - The hash to decode
 * @returns {number|null} - The decoded ID or null if invalid
 */
export const decodeId = (hash) => {
  if (!hash || typeof hash !== 'string') return null;
  const decoded = hashids.decode(hash);
  return decoded.length > 0 ? decoded[0] : null;
};

/**
 * Generate course URL with encoded ID
 * @param {number} courseId - The course ID to encode
 * @returns {string} - The URL path with encoded ID
 */
export const generateCourseUrl = (courseId) => {
  const encodedId = encodeId(courseId);
  return `/app/courses/${encodedId}`;
};

/**
 * Generate chapter URL with encoded ID
 * @param {number} chapterId - The chapter ID to encode
 * @returns {string} - The URL path with encoded ID
 */
export const generateChapterUrl = (chapterId) => {
  const encodedId = encodeId(chapterId);
  return `/app/chapter/${encodedId}`;
};